"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Countdown = _interopRequireDefault(require("../../Countdown/Countdown"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Pill = _interopRequireDefault(require("../../Pill/Pill"));
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
var _buttons = require("../../constants/buttons");
var _constants = require("../../constants");
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _addressBooks = require("../../constants/addressBooks");
var _envConstants = require("../../../env-constants");
var _MediaContext = require("../../MediaContext/MediaContext");
var Video = function Video(_ref) {
  var _mobileVideo$poster, _video$poster;
  var _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    title = _ref.title,
    subtitle = _ref.subtitle,
    topText = _ref.topText,
    logo = _ref.logo,
    whiteFont = _ref.whiteFont,
    video = _ref.video,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {
      text: ""
    } : _ref$cta,
    _ref$cta2 = _ref.cta2,
    cta2 = _ref$cta2 === void 0 ? {
      text: ""
    } : _ref$cta2,
    mobileVideo = _ref.mobileVideo,
    pill = _ref.pill,
    poster = _ref.poster,
    countdown = _ref.countdown,
    renderer = _ref.renderer,
    mobilePoster = _ref.mobilePoster,
    centeredDesktop = _ref.centeredDesktop,
    trailerLink = _ref.trailerLink,
    trustPilot = _ref.trustPilot,
    trustLogos = _ref.trustLogos,
    hls = _ref.hls,
    extraLogo = _ref.extraLogo,
    signUpForm = _ref.signUpForm,
    hideLastName = _ref.hideLastName,
    addressBookId = _ref.addressBookId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hero--video d8-u-bg-img d8-u-relative padding-top-lg padding-top-0@md"
  }, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.SM
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "video"
  }, /*#__PURE__*/_react["default"].createElement("video", {
    className: "width-100% height-auto",
    src: (mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.url) || mobileVideo || (video === null || video === void 0 ? void 0 : video.url) || video,
    playsInline: true,
    autoPlay: true,
    loop: true,
    muted: true,
    poster: (mobilePoster === null || mobilePoster === void 0 ? void 0 : mobilePoster.url) || (mobileVideo === null || mobileVideo === void 0 || (_mobileVideo$poster = mobileVideo.poster) === null || _mobileVideo$poster === void 0 ? void 0 : _mobileVideo$poster.url) || (poster === null || poster === void 0 ? void 0 : poster.url) || poster
  }))), video && /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.SM
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hero--video-wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "video"
  }, /*#__PURE__*/_react["default"].createElement("video", {
    className: "width-100% height-auto",
    src: (video === null || video === void 0 ? void 0 : video.url) || video,
    playsInline: true,
    autoPlay: true,
    loop: true,
    muted: true,
    poster: (poster === null || poster === void 0 ? void 0 : poster.url) || (video === null || video === void 0 || (_video$poster = video.poster) === null || _video$poster === void 0 ? void 0 : _video$poster.url)
  })))), overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-overlay"
  }), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "height-100% max-width-lg flex items-center d8-u-relative flex-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(centeredDesktop && "hero-center margin-auto@sm text-center@sm", "basic-content__wrapper text-component margin-top-auto margin-right-auto")
  }, pill && pill.text && /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    type: "pill--black",
    title: pill.text
  }), logo, topText && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])("text-sm", "d8-u-ls-sm", "d8-u-text-uppercase", whiteFont && "d8-u-color-white")
  }, topText), title && /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _classnames["default"])(whiteFont && "d8-u-color-white", "text-xxxl")
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])("subtitle", "max-width-xxxs", "text-md", whiteFont && "d8-u-color-white", "margin-top-md")
  }, subtitle), countdown && /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
    countdown: countdown
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap"
  }, trailerLink && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md margin-right-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: "Play the video",
      buttonType: _buttons.BUTTON_TYPES.WHITE,
      onClick: toggle,
      icon: "play",
      iconFlip: true,
      buttonSize: _buttons.BUTTON_SIZES.MEDIUM
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on,
      template: "Video",
      video: trailerLink
    }));
  }), (cta.text || signUpForm) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, signUpForm ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    signUp: true,
    hideLastName: hideLastName,
    addressBookId: addressBookId || _addressBooks.ADDRESS_BOOKS["".concat(_envConstants.ENV.SITE, "-footer")],
    imageCardTemplate: "SignUp",
    whiteFont: true,
    bgColor: "transparet",
    size: "auto",
    style: {
      boxShadow: "none",
      padding: "0px",
      margin: "0px"
    }
  })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    link: cta.link,
    external: cta.external,
    text: cta.text,
    buttonType: _buttons.BUTTON_TYPES.PRIMARY,
    icon: cta.icon,
    iconFlip: cta.iconFlip,
    onClick: cta.onClick,
    buttonSize: _buttons.BUTTON_SIZES.MEDIUM
  })), cta2.text && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md margin-left-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    link: cta2.link,
    external: cta2.external,
    text: cta2.text,
    buttonType: _buttons.BUTTON_TYPES.SECONDARY,
    icon: cta2.icon,
    onClick: cta2.onClick,
    iconFlip: cta2.iconFlip,
    buttonSize: _buttons.BUTTON_SIZES.MEDIUM
  }))), title && trustPilot && /*#__PURE__*/_react["default"].createElement("a", {
    href: trustPilot.link,
    className: "block margin-top-lg hide@sm",
    style: {
      maxWidth: 200
    }
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "".concat(trustPilot.score, "-small"),
    fill: trustPilot.color
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between margin-top-auto margin-right-auto width-100%"
  }, trustLogos && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "/flexible-booking",
    className: "flex hero--trust-logo items-center margin-left-md@md margin-top-md margin-top-0@md"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "trust",
    className: "icon--xl",
    fill: "#ffffff"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-white text-sm padding-left-xs margin-top-xs"
  }, "Book with", /*#__PURE__*/_react["default"].createElement("br", null), "confidence"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, extraLogo && /*#__PURE__*/_react["default"].createElement("a", {
    href: extraLogo.link,
    className: "display@sm margin-right-lg"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: extraLogo.name,
    className: "icon--xxl"
  })), trustPilot && /*#__PURE__*/_react["default"].createElement("a", {
    href: trustPilot.link,
    className: "display@sm margin-left-auto",
    style: {
      maxWidth: 124
    }
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: trustPilot.score,
    fill: trustPilot.color
  }))))));
};
Video.propTypes = {
  title: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  video: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  poster: _propTypes["default"].object,
  cta: _propTypes["default"].object,
  cta2: _propTypes["default"].object,
  mobileVideo: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  countdown: _propTypes["default"].string,
  renderer: _propTypes["default"].func,
  mobilePoster: _propTypes["default"].object,
  centeredDesktop: _propTypes["default"].bool,
  trailerLink: _propTypes["default"].string,
  pill: _propTypes["default"].object,
  trustPilot: _propTypes["default"].object,
  logo: _propTypes["default"].node,
  trustLogos: _propTypes["default"].bool,
  hls: _propTypes["default"].bool,
  extraLogo: _propTypes["default"].object,
  signUpForm: _propTypes["default"].bool,
  hideLastName: _propTypes["default"].bool,
  addressBookId: _propTypes["default"].string
};
Video.defaultProps = {
  cta: {
    text: ""
  },
  overlay: true
};
var _default = exports["default"] = Video;